module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Regular.ada74f9.eot";